import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  IconButton,
  Button,
  MenuItem,
  Select,
  Stack,
  Pagination,
  PaginationItem,
  Grid,
} from "@mui/material";
import { TOTALLIMIT } from "../../../utils/localStorage";
import React, { useState, useEffect } from "react";
import EditButton from "../../../assets/icons/EditButton.svg";
import ViewButton from "../../../assets/icons/ViewButton.svg";
import ArrowDown from "../../../assets/icons/ArrowDown.svg";
import TrashButton from "../../../assets/icons/TrashButton.svg";
import ButtonAdd from "../../../assets/icons/ButtonAdd.svg";
import BackArrow from "../../../assets/icons/BackArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import AddChecklistModel from "./AddChecklistModel";
import ViewChecklistModel from "./ViewChecklistModel";
import EditChecklistModel from "./EditChecklistModel";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import {
  getChecklistMastersList,
  deleteChecklistMastersList,
} from "../../../redux/actions/mastersAction";
import noData from "../../../assets/images/Group 688.png";

const ChecklistMasterContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state?.user?.isLoading);

  const checklistMasterPagination = useSelector(
    (state) => state?.masters?.checklistMasterPagination
  );

  const checklistMasterData = useSelector(
    (state) => state?.masters?.checklistMasterData
  );

  const [ChecklistRowData, setChecklistRowData] = useState("");

  const [activeButton, setActiveButton] = useState("Daily");
  const [isAddChecklistModel, setIsAddChecklistModel] = useState(false);
  const [isViewChecklistModel, setIsViewChecklistModel] = useState(false);
  const [isEditChecklistModel, setIsEditChecklistModel] = useState(false);
  const [isPaginationLimit, setIsPaginationLimit] = useState(10);
  const [page, setPage] = useState(1);

  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleChangePage = (e, pagevalue) => {
    setPage(pagevalue);
  };

  const handleButtonClick = (btnname) => {
    setActiveButton(btnname);
  };

  const handleCloseAddChecklistModel = (e) => {
    setIsAddChecklistModel(false);
  };

  const handleCloseViewChecklistModel = (e) => {
    setIsViewChecklistModel(false);
  };

  const handleCloseEditChecklistModel = (e) => {
    setIsEditChecklistModel(false);
  };

  const handleEditChecklistModel = (e) => {
    setIsViewChecklistModel(false);
    setIsEditChecklistModel(true);
  };

  const handleDeleteChecklistMasters = (Checklistid) => {
    dispatch(
      deleteChecklistMastersList({
        id: Checklistid,
      })
    );
  };
  useEffect(() => {
    dispatch(
      getChecklistMastersList({
        checklist_type: activeButton,
        limit: isPaginationLimit,
        offset: page - 1,
      })
    );
  }, [activeButton, isPaginationLimit, page]);

  return (
    <>
      {isAddChecklistModel && (
        <AddChecklistModel
          isAddChecklistModel={isAddChecklistModel}
          handleCloseAddChecklistModel={handleCloseAddChecklistModel}
        />
      )}
      {isViewChecklistModel && (
        <ViewChecklistModel
          isViewChecklistModel={isViewChecklistModel}
          handleCloseViewChecklistModel={handleCloseViewChecklistModel}
          handleEditChecklistModel={handleEditChecklistModel}
          ChecklistRowData={ChecklistRowData}
        />
      )}
      {isEditChecklistModel && (
        <EditChecklistModel
          isEditChecklistModel={isEditChecklistModel}
          handleCloseEditChecklistModel={handleCloseEditChecklistModel}
          ChecklistRowData={ChecklistRowData}
        />
      )}
      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                ml: 2,
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/masters");
              }}
            >
              <img src={BackArrow} alt="" width="17" height="17" />
            </Box>
            <Box>
              <Typography
                sx={{
                  ml: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "#212121",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Checklist Master
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", mr: 2 }}>
            <Box sx={{ display: "flex", mr: 2, alignItems: "center" }}>
              <Typography
                onClick={() => handleButtonClick("Monthly")}
                sx={{
                  padding: "9px 15px 9px 15px",
                  fontSize: "15px",
                  cursor: "pointer",
                  fontWeight: 600,
                  borderRadius: "15px",
                  color: activeButton === "Monthly" ? "#FFFFFF" : "#B5B5C3",
                  backgroundColor:
                    activeButton === "Monthly" ? "#20704D" : "transparent",
                }}
              >
                Monthly
              </Typography>
              <Typography
                onClick={() => handleButtonClick("Weekly")}
                sx={{
                  padding: "9px 15px 9px 15px",
                  fontSize: "15px",
                  cursor: "pointer",
                  fontWeight: 600,
                  borderRadius: "15px",
                  color: activeButton === "Weekly" ? "#FFFFFF" : "#B5B5C3",
                  backgroundColor:
                    activeButton === "Weekly" ? "#20704D" : "transparent",
                }}
              >
                Weekly
              </Typography>
              <Typography
                onClick={() => handleButtonClick("Daily")}
                align="center"
                sx={{
                  padding: "9px 15px 9px 15px",
                  fontSize: "15px",
                  cursor: "pointer",
                  fontWeight: 600,
                  borderRadius: "15px",
                  color: activeButton === "Daily" ? "#FFFFFF" : "#B5B5C3",
                  backgroundColor:
                    activeButton === "Daily" ? "#20704D" : "transparent",
                }}
              >
                Daily
              </Typography>
            </Box>
            {/* <Button
              variant="contained"
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                width: "10rem",
                backgroundColor: "#26875C",
                padding: "8px 15px 5px 15px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#FFFFFF",
                ":hover": {
                  backgroundColor: "#26875C",
                },
              }}
              onClick={() => setIsAddChecklistModel(true)}
            >
              <Box sx={{ marginRight: "10px" }}>
                <img src={ButtonAdd} alt="" />
              </Box>
              Add Checklist
            </Button> */}
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {checklistMasterData.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Checklist ID
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Publish Date
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Department
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Checklist Type
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      No. of Question
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Publish Date
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Time
                    </TableCell> */}
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Action
                    </TableCell>
                    <TableCell> </TableCell>
                  </TableRow>
                </TableHead>
                {isLoading ? (
                  <TableBody>
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={8} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {checklistMasterData.map((row) => (
                      <TableRow
                        // key={row.Checklist}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {`MR${row.display_id.toString().padStart(3, "0")}`}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.department?.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.checklist_type?.name}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {row?.questionCount}
                        </TableCell>
                        {/* <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {moment(row?.checklist_type?.publish_date).format(
                            "D MMMM, YYYY"
                          )}
                        </TableCell>
                        <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                          {moment(row?.checklist_type?.publish_date).format(
                            "hh:mm A"
                          )}
                        </TableCell> */}
                        <TableCell
                          sx={{
                            color: "#464E5F",
                            fontWeight: 600,
                            display: "flex",
                            padding: "23px",
                          }}
                        >
                          {/* <IconButton>
                            <img
                              src={EditButton}
                              width="30"
                              height="30"
                              onClick={() => {
                                setChecklistRowData(row);
                                setIsEditChecklistModel(true);
                              }}
                            />
                          </IconButton> */}
                          <IconButton
                            onClick={() => {
                              setChecklistRowData(row);
                              setIsViewChecklistModel(true);
                            }}
                          >
                            <img src={ViewButton} width="30" height="30" />
                          </IconButton>
                          {/* <IconButton
                            onClick={() =>
                              handleDeleteChecklistMasters(row?.id)
                            }
                          >
                            <img src={TrashButton} width="30" height="30" />
                          </IconButton> */}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            )}
          </TableContainer>
          <Divider />
          {checklistMasterPagination?.totalRecord >= TOTALLIMIT && (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={checklistMasterPagination?.totalPages}
                  onChange={handleChangePage}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          )}
        </Box>
      </Paper>
    </>
  );
};

export default ChecklistMasterContent;
